(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leatherplus-personalised-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLeatherPlus(root) {
    if (!root || root.dataset.lpInitialized === 'true') return;
    root.dataset.lpInitialized = 'true';

    var fullNameInput = root.querySelector('[data-lp-full-name]');
    var initialsInput = root.querySelector('[data-lp-initials]');
    var fontFamilyInputs = root.querySelectorAll('[data-lp-font-family]');
    var fontSample = root.querySelector('[data-lp-font-sample]');
    var tabs = root.querySelectorAll('[data-preview]');
    var productPreviews = root.querySelectorAll('[data-live-product]');
    var buckleNameNode = root.querySelector('[data-live-buckle-name]');
    var beltNameNode = root.querySelector('[data-live-belt-name]');
    var walletNameNode = root.querySelector('[data-live-wallet-name]');
    var initialsNode = root.querySelector('[data-live-initials]');
    var engravingNodes = root.querySelectorAll('.lp-engraving');
    var liveTitle = root.querySelector('[data-live-title]');
    var liveDescription = root.querySelector('[data-live-description]');
    var cartForms = root.querySelectorAll('[data-lp-cart-form]');
    var previewMode = root.dataset.previewMode || 'both';
    var currentProduct = root.dataset.defaultProduct || (previewMode === 'wallet' ? 'wallet' : 'belt');

    if (!fullNameInput || !initialsInput || !fontFamilyInputs.length) return;

    function cleanText(value, fallback, maxLength) {
      var cleaned = String(value || '')
        .replace(/[<>]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
      var safeValue = cleaned || fallback;
      return Array.from(safeValue).slice(0, maxLength).join('');
    }

    function createInitials(name) {
      var parts = cleanText(name, '', 60).split(' ').filter(Boolean);
      if (!parts.length) return 'A.S';
      return parts.slice(0, 3).map(function (part) {
        return Array.from(part)[0] || '';
      }).join('.').toUpperCase();
    }

    function selectedFont() {
      var option =
        root.querySelector('[data-lp-font-family]:checked') ||
        fontFamilyInputs[0];

      return {
        key: option ? option.value : 'great_vibes',

        label:
          option && option.dataset.fontLabel
            ? option.dataset.fontLabel
            : 'Signature script',

        stack:
          option && option.dataset.fontStack
            ? option.dataset.fontStack
            : "'Great Vibes', cursive",

        transform:
          option && option.dataset.textTransform
            ? option.dataset.textTransform
            : 'none'
      };
    }

    function setInputValue(selector, value) {
      root.querySelectorAll(selector).forEach(function (input) {
        input.value = value;
      });
    }

    function fitEngraving(node) {
      if (!node || node.offsetParent === null) return;

      var originalSize = parseFloat(node.dataset.fontSize || '28');
      var minimumSize = node.matches('[data-live-wallet-name]') ? 6 : 8;
      var size = originalSize;

      node.style.fontSize = size + 'px';

      while (
        node.scrollWidth > node.clientWidth + 1 &&
        size > minimumSize
      ) {
        size -= 0.25;
        node.style.fontSize = size + 'px';
      }
    }

    function applyTypography() {
      var font = selectedFont();

      root.style.setProperty('--lp-preview-font-family', font.stack);
      root.style.setProperty('--lp-preview-text-transform', font.transform);

      engravingNodes.forEach(function (node) {
        node.style.fontFamily = font.stack;
        node.style.textTransform = font.transform;
        fitEngraving(node);
      });

      if (fontSample) {
        fontSample.style.fontFamily = font.stack;
        fontSample.style.fontSize = '28px';
        fontSample.style.textTransform = font.transform;
      }

      setInputValue('[data-lp-property-font]', font.label);
    }

    function updatePreview() {
      var maxLength = parseInt(fullNameInput.getAttribute('maxlength'), 10) || 24;
      var fullName = cleanText(fullNameInput.value, 'Aarav Sharma', maxLength);
      var initials = cleanText(initialsInput.value, createInitials(fullName), 5).replace(/\s+/g, '').toUpperCase();

      if (buckleNameNode) buckleNameNode.textContent = fullName;
      if (beltNameNode) beltNameNode.textContent = fullName;
      if (walletNameNode) walletNameNode.textContent = fullName;
      if (initialsNode) initialsNode.textContent = initials;
      if (fontSample) fontSample.textContent = fullName;

      setInputValue('[data-lp-property-name]', fullName);
      setInputValue('[data-lp-property-initials]', initials);
      applyTypography();

      try {
        root.dispatchEvent(new CustomEvent('leatherplus:preview-change', {
          bubbles: true,
          detail: {
            product: currentProduct,
            fullName: fullName,
            initials: initials,
            font: selectedFont().label,
            engravingSizes: { buckle: 28, insideStrap: 40, wallet: 28 }
          }
        }));
      } catch (error) {
        /* CustomEvent is enhancement-only; the preview still works without it. */
      }
    }

    function setProduct(product) {
      if (previewMode === 'belt' || previewMode === 'wallet') product = previewMode;
      currentProduct = product === 'wallet' ? 'wallet' : 'belt';

      productPreviews.forEach(function (preview) {
        var isActive = preview.getAttribute('data-live-product') === currentProduct;
        preview.hidden = !isActive;
      });

      tabs.forEach(function (button) {
        var isActive = button.getAttribute('data-preview') === currentProduct;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      cartForms.forEach(function (form) {
        form.hidden = form.getAttribute('data-lp-cart-form') !== currentProduct;
      });

      if (liveTitle) liveTitle.textContent = currentProduct === 'belt' ? 'Belt preview' : 'Wallet preview';
      if (liveDescription) {
        liveDescription.textContent = currentProduct === 'belt'
          ? 'Customer name on the buckle and inside the strap.'
          : 'Full name inside, initials outside.';
      }

      window.requestAnimationFrame(updatePreview);
    }

    var initialGeneratedInitials = createInitials(fullNameInput.value);
    var initialsAreAutomatic = !initialsInput.value.trim() || initialsInput.value.trim().toUpperCase() === initialGeneratedInitials;

    fullNameInput.addEventListener('input', function () {
      if (initialsAreAutomatic) initialsInput.value = createInitials(fullNameInput.value);
      updatePreview();
    });

    initialsInput.addEventListener('input', function () {
      initialsAreAutomatic = false;
      updatePreview();
    });

    fontFamilyInputs.forEach(function (input) {
      input.addEventListener('change', updatePreview);
    });

    tabs.forEach(function (button) {
      button.addEventListener('click', function () {
        setProduct(button.getAttribute('data-preview'));
      });
    });

    setProduct(currentProduct);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        applyTypography();
      });
    }

    window.addEventListener('resize', function () {
      window.requestAnimationFrame(applyTypography);
    }, { passive: true });
  }

  function findRoot(target) {
    if (!target) return null;
    if (target.matches && target.matches('.lp-personal-page')) return target;
    return target.querySelector ? target.querySelector('.lp-personal-page') : null;
  }

  document.querySelectorAll('.lp-personal-page').forEach(initLeatherPlus);
  document.addEventListener('shopify:section:load', function (event) {
    initLeatherPlus(findRoot(event.target));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
